<div class="container">
    <div class="display-flex mb-4" [formGroup]="form" *ngIf="requireAdditionalInfo">
        <div class="form-group col-12 col-sm-6"
             [class.has-danger]="!additionalInformation.valid && additionalInformation.touched">
            <div class="row">
                <label for="additionalInformation" class="col-12 required-label col-form-label">{{additionalInfoLabel}}</label>
                <div class="col-12 form-control-container">
                    <input formControlName="additionalInformation"
                           [class.form-control-danger]="!additionalInformation.valid && additionalInformation.touched"
                           class="form-control" type="text" value="" id="additionalInformation">
                </div>
            </div>
        </div>
    </div>
    <button type="submit" class="btn btn-secondary m-2 pull-right" [disabled]="isProcessing" (click)="onClickCancel()">Cancel
    </button>
    <button type="button" class="btn btn-primary m-2 px-1 pull-right" [disabled]="isProcessing" (click)="onClickConfirmPass()">Confirm
    </button>
</div>
